module.exports = __webpack_public_path__ + "media/images/pic/labels/materials/pera-pera-1-ecff04d9419b70b2a27a08f2d6c14cd6.jpg";